import countryPhoneCodes from '~/js/modules/country-phone-codes';
import '~/js/modules/stickyNav';
// create new array for countries and appending a new object that represents default value
const countries = [
  {
    name: 'Select A Country',
    id: '',
    regionCode: '',
    code: ''
  },
  {
    name: 'USA',
    id: 210,
    regionCode: 'US',
    code: 'US'
  },
  {
    name: 'CANADA',
    id: 34,
    regionCode: 'CN',
    code: 'CA'
  }
];

// create new array for states and appending a new object that represents default value
const states = [
  ...window.beaches_app.page.states
];

// react form elements contact
import CountryStateSelector from '~/js/components/form-controls/CountryStateSelector';
import CustomRecaptcha from '~/js/components/form-controls/CustomRecaptcha';
import CustomTextarea from '~/js/components/form-controls/CustomTextarea';
import DatesSelector from '~/js/components/groups/DatesSelector';

ReactDOM.render(
  <CustomTextarea
    wrapperClass="groups-message"
    name="description"
    id="description"
    maxLength="250"
    displayCharacterCount
  />,
  document.getElementById('message-textarea')
);

ReactDOM.render(
  <CountryStateSelector
    countries={ countries }
    states={ states }
    countryName="country"
    stateName="state"
    stateLabelWrapper="lg-4"
    stateInputWrapper="lg-8"
    countryLabelWrapper="lg-4"
    countryInputWrapper="lg-8"
  />,
  document.getElementById('country-state-selector')
);

ReactDOM.render(
  <DatesSelector
    fromName="arrival"
    toName="departure"
  />,
  document.getElementById('estimated-date')
);

ReactDOM.render(
  <CustomRecaptcha
    wrapperClassName="xs-12"
  />,
  document.getElementById('google-recaptcha')
);


const $subscribeLabel = $('.form-label[for="subscribe"]');

$subscribeLabel.html($subscribeLabel.data('normal'));

// SMS opt-in
const smsProp = document.querySelector(".sms");
const countryInput = document.querySelector("#gcvCountryFieldId");
const smsCheckBox = document.querySelector("#subscribeSms");

countryInput.addEventListener("change", function(event){

  if(event.target.value === "US"){
    smsProp.classList.remove("hideSms");
    smsProp.classList.add("showSms");
  }
  else if(event.target.value !== "US"){
    smsProp.classList.add("hideSms");
    smsProp.classList.remove("showSms");

    if(smsCheckBox.checked===true){
      smsCheckBox.checked = false;
    }
  }
})

// form validations
import '~/js/modules/fend';

$('.groups-contact-form').fend({
  rules: {
    firstName: 'lettersOnly',
    lastName: 'lettersOnly',
    jobTitle: 'lettersOnly',
    company: 'lettersOnly',
    city: 'lettersOnly',
    address: 'alphanumeric',
    zipCode: 'alphanumeric',
    departure: {
      greaterThan: 'input[name="arrival"]'
    },
    confirmEmail: {
      equalTo: '#email'
    }
  },
  messages: {
    confirmEmail: 'Email must be the same'
  }
});

const landlineInputId = 'landLineNumber';
const mobileInputId = 'mobileNumber';
const $landlineNumber = $('#landLineNumber');
const $mobileNumber = $('#mobileNumber');
const inputEvaluation = (inputElement, mirrorInputId) => {

  $(`#${mirrorInputId}`).removeAttr('required');
  $(`#${mirrorInputId}-error`).remove();
};

$(`#${landlineInputId}`).on('change', (event) => {
  const inputElement = event.target;

  if (inputElement.value) {
    inputEvaluation(inputElement, mobileInputId);

  } else {

    $(`#${mobileInputId}`).attr('required', true);
  }
});

$(`#${mobileInputId}`).on('change', (event) => {
  const inputElement = event.target;

  if (inputElement.value) {
    inputEvaluation(inputElement, landlineInputId);
  } else {
    $(`#${landlineInputId}`).attr('required', true);
  }
});

$('#other').on('change', () => {
  $('.interest-other-specify').find('input[name="other-specify"]').toggleClass('hidden-validation');
});

$(document).ready( () => {
  if ($landlineNumber.val()) {
    $mobileNumber.removeAttr('required');
    $mobileNumber.trigger( 'blur' );
  }

  if ($mobileNumber.val()) {
    $landlineNumber.removeAttr('required');
    $landlineNumber.trigger( 'blur' );
  }

  //FOR COUNTRY CODE
  $('[name=country]').on('change', function() {
    const selectedCountry = $(this).val();
    const phoneCode = countryPhoneCodes.find((obj) => obj.code === selectedCountry).dial_code;

    $('span.countryCode').html(phoneCode);
  });
});
